<template>
  <div v-if="consognment" class="container-fluid invoice-container-con ">
        <!-- Header -->
        <header>
            <div class="row align-items-center mt-5">
                <div class="col-4 text-center mb-3 mb-sm-0">
                    <img id="logo" src="../../../assets/imgs/logo.jpg" title="bashundhara" alt="Bashundhara roti" height="100"/>
                </div>
                <div class="col-8 text-center mb-3 mb-sm-0">
                    <h4>Delivery Run Sheet</h4> 
                    <strong>Consignment ID :</strong> {{consognment.unique_id}}
                </div>
            </div>
            <hr>
        </header>

        <!-- Main Content -->
        <main>
            <div class="row p-3 pb-0">
                <div class="col-4">
                    <strong>DATE OF DISPATCH:</strong>  {{consognment.date || ''}} <br>
                    <strong>DELIVERY HUB:</strong> {{consognment.hub.name}} <br>
                    <strong>Rider NAME:</strong> {{consognment.rider.name}} <br>
                    <strong>DRIVER PHONE:</strong> {{consognment.rider.mobile}} <br>
                    <!-- <strong>COMMENT:</strong> <br> -->
                </div>
                <div class="col-8 cilavery-content"> 
                    <div class="row">
                        <div class="col-6">
                            <table>
                                <thead>
                                    <tr>
                                        <th colspan="2">NAME & SIGNATURE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>DISPATCHER</td>
                                        <td style="width: 200px"></td> 
                                    </tr>
                                    <tr>
                                        <td>SECURITY</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>DRIVER</td>  
                                        <td></td>     
                                    </tr>
                                    <tr>
                                        <td>FINANCE</td>  
                                        <td></td>     
                                    </tr>
                                </tbody>           
                            </table>
                        </div>
                        <div class="col-6">
                            <table>
                                <thead>
                                    <tr>
                                        <th colspan="2">NAME & SIGNATURE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>AMOUNT REMITTED (DRIVER)</td>
                                        <td style="width: 200px"></td> 
                                    </tr>
                                    <tr>
                                        <td>AMOUNT RECEIVED
                                            (FINANCE)</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>DIFFERENCE</td>  
                                        <td></td>     
                                    </tr>
                                    <tr>
                                        <td>Product Quantity</td>  
                                        <td></td>     
                                    </tr>
                                </tbody>           
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="html2pdf__page-break"/>
            
            <div class="card" style="border-color: transparent;">
                <div class="card-body">
                    <table style="width:100%; font-size: 10px">
                        <tr>
                            <th>#</th>
                            <th>ADDRESS</th>
                            <th>Order</th>
                            <th>Product</th>
                            <th>Type</th>
                            <!-- <th>ACT QTY</th> -->
                            <th>CONTACT</th>
                            <th>Additional Note </th>
                        </tr>
                        <template v-for="(task, key) in consognment.tasks">
                            <template >
                                <tr :key="'hello' + task.id">
                                    <td>{{key + 1}}</td>
                                    <td>{{task.order.customer.address || ''}}</td>
                                    <td>
                                        {{task.order.unique_id}} <br>
                                        {{task.order.zone && task.order.zone.name ? task.order.zone.name : ''}}
                                    </td>
                                    <td>
                                        Product Qty : {{task.order.details.length || 0}}
                                    </td>
                                    <td>{{task.order.order_status.name || ''}}</td>
                                    <!-- <td></td> -->
                                    <td>
                                        Name : {{task.order.customer.name}}
                                        Mobile: {{task.order.customer.mobile}} ,
                                    </td>
                                    <td>
                                        {{ task.order.additional_note }}
                                    </td>
                                </tr>
                                <!-- <div :key="n" :class="n%6 == 0 ? 'html2pdf__page-break' : ''"/> -->

                            </template>
                        </template>
                    </table>

                    <div class="mt-5">
                        Signature:
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    props: ['consognment']
}
</script>
<style lang="scss" scoped>
    .invoice-container-con {
        font-size: 10px !important;

        table,thead,tbody, tr, td,th{
            text-align: center;
            margin: auto;
            border: 1px solid #000 !important;
            padding: 10px;
            font-size: 10px;
        }

        .cilavery-content {
            table,thead,tbody, tr, td,th{
                padding: 0.7rem;
            }
        }
    }
</style>